<template>
    <modal :id="modal" :name="modal" :width="'100%'" :height="'auto'" :scrollable="true" :adaptive="true" :close-on-backdrop="false" :close-on-esc="false" :click-to-close="false"
    styles="background-color: #AB1F08 !important; 
                margin-bottom: 60px !important;
                overflow-y: scroll; 
                max-width: 1000px; 
                margin: 0 auto;">
        <div class="button-close-position">
            <button class="button-close"
                @click="hideModal()">
                X
            </button>
        </div>
     
        <div class="responsive-iframe">
            <video width="100%" controls autoplay>
                <source :src="'images/mpower-new/'+video" type="video/mp4">
            </video>
        </div>
    
        <div class="margin-bottom-90 padding-left-15 padding-right-15 padding-top-20 mobile-display" :style="loadMobileBg">
            <div class="content bottom-0">
                <div class="one-half ovr-small-half">
                    <div class="border-10">
                        <div class="caption-image">
                            <img v-bind:src="'images/mpower-new/'+badge" class="responsive-image img-height-90">
                        </div>
                    </div>
                </div>
                <div class="one-half large-half last-column text-left">
                    <p class="font-17 margin-bottom-0 color-white line-normal">{{title}}</p>
                    <p class="font-17 margin-bottom-0 color-white line-normal">{{title1}}</p>
                    <p class="font-12 convention margin-bottom-0">{{description1}}</p>
                    <p v-if="modal=='thailand-modal'" class="font-10 color-white line-normal margin-top-5">Eligibility: Y1 Agents & Introducers</p>
                    <p class="font-10 color-white line-normal  margin-top-5">{{description2}}</p>
                </div>
                <div class="clear"></div>
            </div>
            <br>
            <div v-if="modal=='star-modal'">
                <div class="content banner-card text-left">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">Y1Y2 AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ y1y2agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR or 90% CYPR (whichever is higher)</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge y1y2-agents">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM138,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge agents">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM168,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">LEADER PS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ leaderpspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge leader-ps">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM208,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content banner-card text-left" style="margin-bottom:0px;">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">DIRECT UNIT</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ directunitpvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge direct-unit">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM504,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">GROUP</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ grouppvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>80% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge group">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM1,008,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="modal=='elite-modal'">
                <div class="content banner-card text-left">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">Y1Y2 AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ y1y2agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>90% CYPR or 85% 1YPR (whichever is higher)</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge y1y2-agents">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM288,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge agents">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM348,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">LEADER PS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ leaderpspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge leader-ps">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM428,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content banner-card text-left" style="margin-bottom:0px;">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">DIRECT UNIT</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ directunitpvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge direct-unit">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM1,004,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">GROUP</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ grouppvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>80% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge group">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM2,008,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <p class="tnc-text">
                General & standard Terms and Conditions apply.Please refer to memorandum GMLAM2026-002a for more details.
            </p>
        </div>
        <div class="margin-bottom-90  padding-left-15 padding-right-15 padding-top-20 ipad-display" :style="loadTabletBg">
            <div class="content bottom-0">
                <div class="one-half ovr-small-half">
                    <div class="border-10">
                        <div class="caption-image">
                            <img v-bind:src="'images/mpower-new/'+badge" class="responsive-image img-height-90">
                        </div>
                    </div>
                </div>
                <div class="one-half large-half last-column text-left">
                    <p class="font-17 margin-bottom-0 color-white line-normal">{{title}}</p>
                    <!-- <p class="font-17 margin-bottom-0 color-white line-normal">{{title1}}</p> -->
                    <p class="font-12 convention margin-bottom-0">{{description1}}</p>
                    <!-- <p v-if="modal=='thailand-modal'" class="font-10 color-white line-normal margin-top-5">Eligibility: Y1 Agents & Introducers</p> -->
                    <p class="font-10 color-white line-normal  margin-top-5">{{description2}}</p>
                </div>
                <div class="clear"></div>
            </div>
            <br>
            <div v-if="modal=='star-modal'">
                <div class="content banner-card text-left">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">Y1Y2 AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ y1y2agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR or 90% CYPR (whichever is higher)</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge y1y2-agents">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM138,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge agents">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM168,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">LEADER PS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ leaderpspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge leader-ps">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM208,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content banner-card text-left" style="margin-bottom:0px;">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">DIRECT UNIT</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ directunitpvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge direct-unit">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM504,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">GROUP</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ grouppvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>80% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge group">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM1,008,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="modal=='elite-modal'">
                <div class="content banner-card text-left">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">Y1Y2 AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ y1y2agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>90% CYPR or 85% 1YPR (whichever is higher)</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge y1y2-agents">EARLY BIRD</span>
                                <div class="award-dates">
                                   <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM288,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">AGENTS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ agentspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge agents">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM348,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">LEADER PS</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ leaderpspvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>12 cases</li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge leader-ps">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM428,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content banner-card text-left" style="margin-bottom:0px;">
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">DIRECT UNIT</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ directunitpvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>85% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge direct-unit">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM1,004,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="award-section">
                        <span class="font-12 line-normal color-grey bold">GROUP</span>
                        <div class="award-content">
                            <div class="award-left">
                                <ul>
                                    <li>RM{{ grouppvi }} PVI <span class="full-year-badge">Full Year</span></li>
                                    <li>80% 1YPR</li>
                                </ul>
                            </div>
                            <div class="award-right">
                                <span class="early-bird-badge group">EARLY BIRD</span>
                                <div class="award-dates">
                                    <div class="font-10 color-red bold">Jan - Nov 2026</div>
                                    <div class="font-12 color-red bold">RM2,008,000 PVI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
          
            <p class="tnc-text">
                General & standard Terms and Conditions apply.Please refer to memorandum GMLAM2026-002a for more details.
            </p>
        </div>
    </modal>
</template>
<style>
    .new-close-position{
        position: absolute;
        z-index: 1;
        top: -10px;
        left: -10px;
    }

    .bold{
        font-family: 'HelveticaNeueLTStd-Bd';
    }

    .award-section {
        margin-bottom: 15px;
    }

    .award-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 10px;
    }

    .award-left {
        flex: 1;
    }

    .award-left ul {
        margin: 0;
        padding-left: 15px;
    }

    .award-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        text-align: right;
        margin-left: 20px;
    }

    .early-bird-badge {
        font-size: 10px;
        font-weight: bold;
        color: white;
        padding: 3px 8px;
        border-radius: 12px;
        margin-bottom: 5px;
        white-space: nowrap;
    }

    .early-bird-badge.y1y2-agents {
        background-color: #579be7;
    }

    .early-bird-badge.agents {
        background-color: #52b9ce;
    }

    .early-bird-badge.leader-ps {
        background-color: #5ecda0;
    }

    .early-bird-badge.direct-unit {
        background-color: #add063;
    }

    .early-bird-badge.group {
        background-color: #f7c544;
        color: black;
    }

    .award-dates {
        text-align: right;
        line-height: 1.2;
    }

    .color-red {
        color: #DC3545;
    }

    .full-year-badge {
        background-color: #6C757D;
        color: white;
        font-size: 9px;
        padding: 2px 6px;
        border-radius: 8px;
        margin-left: 5px;
    }

    .font-10 {
        font-size: 10px;
    }

    .bangkok-header{
        height: 300px;
        width: auto;
        padding-top: 20px;
    }

    .tnc-text{
        font-size: 11px;
        color: #DADAD9;
        text-align: left;
        padding-left: 20px;
        line-height: normal;
    }

    .convention{
        color: #C6C6C6;
    }

    .banner-card{
        /* background-color: #dadad9 !important; */
        color: #7B7B7A;
    }
    
    .explore-banner{
        background-color: #AB1F08 !important; margin-bottom: 60px !important;
        overflow-y: scroll; max-width: 1000px; margin: 0 auto;

    }
    body.modal-open {
        overflow: hidden;
    }
   
    .button-close-position{
        position: absolute;
        z-index: 1;
        top: 5px;
        right: 5px;
    }
    .button-close {
        background-color: grey;
        height: 30px;
        width: 30px;
        border-radius: 16px;
        cursor: pointer;
        font-weight: bold;
        margin-right: 10px;
        margin-top: 10px;
    }
    .border-10{
        border-radius: 10px !important;
    }
    .modal-custom {
        background-color: #191919 !important;
    }
    .margin-20 {
        margin-bottom: 20px !important;
    }
    ul {
        margin-left: 15px;
        margin-bottom: 0 !important;
    }
    ul > li {
        margin-bottom: 0 !important;
        line-height: normal !important;
        color : #7B7B7A;
    }
    p {
        margin-bottom: 0 !important;
    }
    p.margin-btm {
        margin-bottom: 20px !important;
    }
    .line-normal {
        line-height: normal;
    }
    .font-18 {
        font-size: 18px;
    }
    .font-15 {
        font-size: 15px;
    }
    .paragraph {
        color : #C6C6C6;
    }
    .first-column{
        width: 40% !important;
    }
    .img-height-90 {
        height: 90px !important;
    }
    .ovr-small-half {
        margin-right: 5% !important;
        width: auto !important;
    }
    @media (max-width: 325px){
        .content {
            margin: 0px 15px 20px 15px!important;
        }
    }
    @media (min-width: 768px){
        .ovr-small-half {
            margin-right: 2% !important;
        }
    }
</style>
<script>
export default {
    name: 'ExploreBannerContent',
    props: {
        modal: String,
        icon: String,
        title: String,
        title1: String,
        description1: String,
        description2: String,
        color: String,
        image: String,
        positionSlide2: String,
        link: String,
      
        y1y2agentspvi: String,
        agentspvi: String,
        leaderpspvi: String,
        directunitpvi: String,
        grouppvi: String,

        badge: String,
        video:String
    },
    components: {},
    computed: {
        loadMobileBg(){
            return {
                'backgroundImage':'url(../images/mpower-new/background/home/mobile.png)',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
            }
        },
        loadTabletBg(){
            return {
                'backgroundImage':'url(../images/mpower-new/background/home/iPad.png)',
                'background-size': 'cover',
                'background-repeat': 'no-repeat'
            }
        },
    },
    methods: {
      hideModal() {
        document.querySelector(".header-s").style.display = "block";
        document.querySelector(".header").style.zIndex = "96";
          this.$modal.hide(this.modal)
      },
    }
}
</script>
